import type { StatementData } from '@/content/types';

export default function Statement(props: StatementData) {
  return (
    <section className="container section-padding" style={{ textAlign: 'center', paddingTop: 80, paddingBottom: 80 }}>
      <h2 className="h-display" style={{ lineHeight: 1.1 }}>
        {props.title}
        {props.highlight && (
          <>
            <br />
            <span style={{ background: 'var(--gradient-text-blue)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              {props.highlight}
            </span>
          </>
        )}
      </h2>
    </section>
  );
}
